import { useEffect } from "react";

import newRelicAgent from "./scripts/nr-loader-spa.1.252.0.min.js?url";

const id = import.meta.env.VITE_NEW_RELIC_ID as string | undefined;
const nrkey = import.meta.env.VITE_NEW_RELIC_KEY as string | undefined;

const isConfigured = !!(id && nrkey);
if (!isConfigured) {
  console.warn("Skipping NewRelic import.meta.env", {
    VITE_NEW_RELIC_ID: id,
    VITE_NEW_RELIC_KEY: nrkey,
  });
}

const NewRelic = isConfigured
  ? () => {
      useEffect(() => {
        if (typeof window === "undefined") return;

        const configScript = document.createElement("script");
        configScript.innerHTML = `;window.NREUM||(NREUM={});NREUM.init={jserrors:{enabled:true},logging:{enabled:false},metrics:{enabled:true},page_view_timing:{enabled:true},spa:{enabled:false},soft_navigations:{enabled:false},page_action:{enabled:true},page_view_event:{enabled:true},user_actions:{enabled:false},generic_events:{enabled:true},session_replay:{enabled:false},session_trace:{enabled:false},ajax:{enabled:true},privacy:{cookies_enabled:true}};;NREUM.loader_config={accountID:"225023",trustKey:"225023",agentID:"${id}",licenseKey:"${nrkey}",applicationID:"${id}"};;NREUM.info={beacon:"bam.nr-data.net",errorBeacon:"bam.nr-data.net",licenseKey:"${nrkey}",applicationID:"${id}",sa:1};`;
        document.head.appendChild(configScript);

        const agentScript = document.createElement("script");
        agentScript.type = "text/javascript";
        agentScript.src = newRelicAgent;
        agentScript.async = true;
        document.head.appendChild(agentScript);
      }, []);
      return null;
    }
  : () => null;

export default NewRelic;
